<template>
  <div class="row">
    <form-calendar
      v-model="agendamento.data_prevista"
      grid="6"
      label="Data do Agendamento"
    />
    <form-calendar
      v-model="agendamento.hora_prevista"
      grid="6"
      label="Hora do Agendamento"
      mode="time"
    />

    <form-textarea
      v-model="agendamento.descricao"
      grid="12"
      label="Observações"
      id="agendamento-descricao"
    />
  </div>
</template>

<script>
export default {
  props: ["agendamento"],
};
</script>

<style lang="scss" scoped></style>
